export default __webpack_public_path__ + "static/media/frog_R1_C4.144223a6.png";